import { createI18n } from 'vue-i18n'
import Cookies from 'js-cookie'
import enLocale from './en'
import zhLocale from './zh'
import jaLocale from './ja'
import apiErrorCodes from './api-error-codes'

// 导入 Element Plus 语言包
import elementEnLocale from 'element-plus/es/locale/lang/en'
import elementZhLocale from 'element-plus/es/locale/lang/zh-cn'
import elementJaLocale from 'element-plus/es/locale/lang/ja'

export const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  },
  ja: {
    ...jaLocale
  }
}

const DEFAULT_NO_TOAST_CODES = [
  200, 401, 405, 499, 501, 713, 719, 740, 807, 810, 873,
  900, 901, 902, 903, 904, 20000, 20001
]

const TOAST_OVERRIDE_RULES = [
  {
    pattern: /^webModels\/upload$/,
    codes: [403],
    needToast: true
  },
  {
    pattern: /^webModels\/\d+$/,
    codes: [866],
    needToast: false
  }
]

export function getApiErrorCodes(url = '') {
  return apiErrorCodes.map(item => {
    const rule = TOAST_OVERRIDE_RULES.find(rule => rule.codes.includes(item.code))
    if (rule) {
      const matched = rule.pattern.test(url)
      return { ...item, noToast: matched ? !rule.needToast : rule.needToast }
    }
    return DEFAULT_NO_TOAST_CODES.includes(item.code) ? { ...item, noToast: true } : item
  })
}

export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage
  // if has not choose language
  return 'ja'
}

// 新增：获取 Element Plus 语言包的函数
export function getElementPlusLocale(locale) {
  const elementLocales = {
    'en': elementEnLocale,
    'zh': elementZhLocale,
    'ja': elementJaLocale
  };
  const lang = locale || getLanguage()
  return elementLocales[lang] || elementEnLocale; // 默认为英文
}
const i18n = createI18n({
  legacy: false, 
  globalInjection: true,
  locale: getLanguage(),
  fallbackLocale: 'ja',
  messages
})

/**
 * 更新页面上所有带有 data-lang-key 属性的元素文案
 * @param {string} locale - 语言代码 (en, zh, ja)
 */
export function updatePageLanguage(locale = getLanguage()) {
  
  i18n.global.locale.value = locale
  Cookies.set('language', locale)
  
  const elements = document.querySelectorAll('[data-lang-key]')
  
  const updates = []
  
  elements.forEach(element => {
    const attr = Array.from(element.attributes)
    .filter(attr => !attr.name.startsWith('data-lang'))
    .map(attr => [attr.name, attr.value.replace(/\$lang\((.*?)\)/g, (match, key) => {
      return i18n.global.t(key || match)
    })])
   
    const key = element.getAttribute('data-lang-key')

      try {
        const translatedText = key.replace(/\$lang\((.*?)\)/g, (match, _key) => {
          return i18n.global.t(_key || match)
        })
        updates.push({
          element,
          text: translatedText,
          ...Object.fromEntries(attr),
          isInput: element.tagName === 'INPUT',
        })
      } catch (error) {
        console.warn(`Translation key not found: ${key}`, error)
      }
    
  })
  if (updates.length > 0) {
    requestAnimationFrame(() => {
      updates.forEach(({ element, text, isInput, ...attr }) => {
        if(!isInput) {
          element.textContent = text
        }
        Object.entries(attr).forEach(([name, value]) => {
          element.setAttribute(name, value)
        })
      })
    })
  }
}

export default i18n 